export default "__VITE_ASSET__BZ6AIll___"